import { Injectable } from "@angular/core";

import { Subject } from "rxjs";

import { MenuDropdownDirective } from "./menu-dropdown.directive";

@Injectable({ providedIn: 'root' })
export class MenuExpandedService {
    expanded$: Subject<MenuDropdownDirective> = new Subject<MenuDropdownDirective>();
}